import { Route } from 'react-router-dom';
import { faCode, faPowerOff } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MenuManager from '@yooink/youtils/es/MenuManager';
import { LoadComponent } from '@yooink/youtils/es/LoadComponent';
import { FaUser } from 'react-icons/fa';
import { DiNodejsSmall } from 'react-icons/di';
import { addPropsToComponent } from '@yooink/youtils/es/AddPropsToComponent';
import { GiCardboardBoxClosed } from 'react-icons/gi';
import { useHistory } from 'react-router';
import { SuperUsersRoute } from './Users/SuperUsersRoute';
import UISettings from './UISettings';
import LocalizationManager from './LocalizationManager';
import I18nEditor from './LocalizationManager/I18nEditor';
import { TelegramBotSettings } from './TelegramBot';
import { MaintainceScriptsRoute } from './MaintenanceScripts/maintainceScriptsRoute';
import { useSpotlightActions } from '../../AppSpotlight';

MenuManager.RegisterGroup(
	{
		key: 'system',
		name: 'Система',
		icon: <FontAwesomeIcon icon={faPowerOff} />,
		position: 99
	},
	[
		{
			path: '/system/profile',
			name: 'Профиль',
			icon: <FaUser />
		},
		{
			acl: 'system.siteSettngs.ui',
			icon: <FontAwesomeIcon icon={faCode} />,
			path: '/system/siteSettings',
			name: 'Site settings (Прямой доступ)'
		},
		{
			acl: 'system.admins.list',
			icon: <FaUser />,
			path: '/system/users',
			name: 'Администраторы'
		},
		{
			acl: 'system.maintenance',
			icon: <DiNodejsSmall />,
			path: '/system/maintenanceScripts',
			name: 'Скрипты обслуживания'
		}
	]
);

const SiteSettings = LoadComponent(() => import('./SiteSettings'));
const Profile = LoadComponent(() => import('./Profile'));
const System = () => {
	const history = useHistory();
	useSpotlightActions([{
		id: 'system.profile',
		title: 'Профиль администратора',
		onTrigger: () => history.push('/system/profile')
	}, {
		id: 'system.admins',
		title: 'Администраторы',
		onTrigger: () => history.push('/system/users')
	}, {
		id: 'system.maintenanceScripts',
		title: 'Скрипты обслуживания',
		onTrigger: () => history.push('/system/maintenanceScripts')
	}]);

	return (
		<>
			<Route exact path="/system/profile" component={Profile} />
			<Route exact path="/system/siteSettings" component={SiteSettings} />
			<Route exact path="/system/ui" component={UISettings} />
			<Route
				path="/system/maintenanceScripts"
				component={addPropsToComponent(
					{
						path: '/system/maintenanceScripts'
					},
					MaintainceScriptsRoute
				)}
			/>

			<Route exact path="/system/localization" component={LocalizationManager} />
			<Route exact path="/system/localization/i18n" component={I18nEditor} />
			<Route exact path="/system/telegramBot" component={TelegramBotSettings} />

			<SuperUsersRoute />
		</>
	);
};

export default System;
